import axios from "axios";
import {loadStripe} from "@stripe/stripe-js";

export const createInvoice = async () => {
    const linkID = window.location.pathname.substring(1)
    const stripesecretkey = process.env.STRIPE_SECRET_KEY as string;
    if(!stripesecretkey){
        alert("Stripe Secret Key is not set")
    }
    const stripe = await loadStripe(stripesecretkey);
    console.log(linkID)
    console.log('env::::' + process.env.TEST_VAR)
    const {data} = await axios.post('/api/create', {id: linkID});
    await stripe?.redirectToCheckout({sessionId: data.id})
}

createInvoice();